
import Vue from 'vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(
    'section',
    { staticClass: 'about' },
    [
      _c('secondary-nav'),
      _c('div', { staticClass: 'su-body' }, [
        _c('div', { staticClass: 'about-us-section container' }, [
          _c('div', { staticClass: 'row' }, [
            _c('div', { staticClass: 'col-1 void-column' }),
            _c(
              'div',
              { staticClass: 'col-11 col-md-10' },
              [
                _c('div', { staticClass: 'row' }, [
                  _c('div', {
                    staticClass: 'col-12 policy-content',
                    domProps: { innerHTML: _vm._s(_vm.cookie_policy) },
                  }),
                ]),
                _c('footer-row'),
                _c('alert-row', { ref: 'alertMsg' }),
              ],
              1,
            ),
          ]),
        ]),
      ]),
    ],
    1,
  );
};
var staticRenderFns = [];

export default Vue.extend({
  render,
  staticRenderFns,
  data() {
    return {
      cookie_policy: '',
      loading: true,
      error: false,
    };
  },
  mounted() {
    fetch('https://www.iubenda.com/api/privacy-policy/59164233/cookie-policy/no-markup')
      .then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then((data) => {
        this.cookie_policy = data.content;
        this.loading = false;
      })
      .catch(() => {
        this.error = true;
        this.loading = false;
        this.cookie_policy =
          '<p>Impossibile caricare la Cookie Policy. <a href="https://www.iubenda.com/privacy-policy/59164233/cookie-policy" target="_blank" rel="noopener">Visualizzala su Iubenda</a>.</p>';
      });
  },
});
